goog.provide("shadow.js.shim.module$$mui$material$AlertTitle");
goog.provide("module$shadow_js_shim_module$$mui$material$AlertTitle");
shadow.js.shim.module$$mui$material$AlertTitle = shadow.js.nativeProvides["@mui/material/AlertTitle"] = shadow$bridge("@mui/material/AlertTitle");
module$shadow_js_shim_module$$mui$material$AlertTitle.default = shadow.js.shim.module$$mui$material$AlertTitle;
